import React from "react";
import { Heading, Text } from "@smartling-ui/typography";

import * as styles from "./styles.module.css";

type Props = {
    heading: string;
    description?: string;
    footer?: React.ReactNode;
    children: React.ReactNode;
}

export function FormStepLayout({ heading, description, footer, children }: Props) {
    return (
        <div className={styles.layout}>
            <div className={styles.header}>
                <Heading size="lg" as="h1">{heading}</Heading>
                {description && (
                    <Text as="p" color="soft" size="sm">{description}</Text>
                )}
            </div>

            {children}

            {footer && (
                <div className={styles.footer}>
                    {footer}
                </div>
            )}
        </div>
    );
}
